import React from "react";
import FlightBookings from "./Flights";

function Bookings() {
	return (
		<div className="p-4 pt-0 pb-24 -mt-2">
			<div className="mb-4 rounded-lg border border-surface bg-canvas p-3 text-sm text-secondary">
				Track your own trip requests, confirmed bookings, and approved requests waiting to be booked.
			</div>
			<FlightBookings />
		</div>
	);
}

export default Bookings;
